import { createContext, useContext } from 'react';

export type SimulatedViewport = {
  active: boolean;
  width: number;
  height: number;
};

const SimulationFrameContext = createContext<SimulatedViewport>({
  active: false,
  width: 0,
  height: 0,
});

export { SimulationFrameContext };

export function useSimulationFrame(): boolean {
  return useContext(SimulationFrameContext).active;
}

export function useSimulatedViewport(): SimulatedViewport {
  return useContext(SimulationFrameContext);
}
